import React from "react";

//css
import './footer.css'

const Footer = () => {

    return <div className="footer">
        <p>This site created by @Asaf Almog 2021</p>
    </div>

}
export default Footer